import type { LanguageCode } from 'iso-639-1'
import { LANGUAGES_SORTED } from '../constants/language.ts'
import language, { type LocaleCode, type LocalizedLanguageNames } from '../language.ts'

export const getLangs = () => {
    return language.langs()
}

export const getLanguages = (lang: LocaleCode): LocalizedLanguageNames => {
    const langs = language.getNames(lang)
    const entries = Object.entries(langs)

    const prioritizedEntries = LANGUAGES_SORTED.map((key) => [key, langs[key]])
    const remainingEntries = entries.filter(([key]) => !LANGUAGES_SORTED.includes(key as LanguageCode))
    const sortedEntries = [...prioritizedEntries, ...remainingEntries]

    return Object.fromEntries(sortedEntries)
}

export const getLanguageNameFromCode = (code: LanguageCode | string, lang: LocaleCode): string | undefined => {
    return language.getName(code, lang)
}

export const getLanguageCodeFromName = (name: string, lang: LocaleCode): LanguageCode | undefined => {
    return language.getAlpha2Code(name, lang) as LanguageCode | undefined
}
